export default function setOrderBy(orderBy) {
	this._updateSearchResults({
		pageNumber: 1,
		orderBy,
	})
}
